import { DonutChart, IChartDataPoint } from '@fluentui/react-charting';
import React from 'react';
import { useGetProcurementDemandItemCountsByVendorQuery } from '../../../store/endpoints/ProcurementEndpoints';
import Widget from '../../Common/Widgets/Widget';
import { ICommandBarItemProps, Spinner, SpinnerSize } from '@fluentui/react';

interface IPendingProductsWidgetProps {
    onVendorClick: (vendor: string) => void;
}

const PendingProductsWidget: React.FC<IPendingProductsWidgetProps> = (props) => {
    const data = useGetProcurementDemandItemCountsByVendorQuery();
    const [chartData, setChartData] = React.useState<IChartDataPoint[]>([]);
    const [total, setTotal] = React.useState<number>(0);

    React.useEffect(() => {
        if (data.data) {
            const chartPoints: IChartDataPoint[] = Object.entries(data.data)
                .sort(([, countA], [, countB]) => countB - countA)
                .map(([vendor, count]) => ({
                    legend: vendor,
                    data: count,
                    onClick: () => props.onVendorClick(vendor),
                }));
            setChartData(chartPoints);
            setTotal(Object.values(data.data).reduce((sum, count) => sum + count, 0));
        }
    }, [data.data, props.onVendorClick]);

    const refetch = () => {
        data.refetch();
    }

    const rightCommands: ICommandBarItemProps[] = [
        {
            key: 'refresh',
            text: 'Refresh',
            iconOnly: true,
            iconProps: { iconName: 'Refresh' },
            onClick: refetch 
        }
    ]

    return <Widget
        header='Pending Products by Vendor'
        rightCommands={rightCommands}
        size='small'
        grow={0}
        >
            {data.isFetching
            ? <Spinner
                label='Loading'
                size={SpinnerSize.large}
                style={{marginTop: '3em'}}
                styles={{
                    circle: {
                        width: '90px',
                        height: '90px',
                        borderWidth: '6px'
                    }
                }}
                />
            : <DonutChart
                data={{
                    chartData: chartData,
                }}
                hideLabels={false}
                height={225}
                width={225}
                innerRadius={40}
                valueInsideDonut={total}
                styles={{
                     root: {
                        height: '225px'
                     }
                }}
            />
            }

    </Widget>

};

export default PendingProductsWidget;